import { render } from "./ErrorLogs.vue?vue&type=template&id=6926c250"
import script from "./ErrorLogs.vue?vue&type=script&lang=js"
export * from "./ErrorLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ErrorLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6926c250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6926c250', __exports__)) {
    api.reload('6926c250', __exports__)
  }
  
  module.hot.accept("./ErrorLogs.vue?vue&type=template&id=6926c250", () => {
    api.rerender('6926c250', render)
  })

}


export default __exports__